$(document).ready(function () {
  const slides = document.querySelectorAll('.featured-product-slider-item');

  const swiper = new Swiper('.featured-product-slider .featured-product-slider-items.swiper-container', {
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-next-btn",
      prevEl: ".swiper-prev-btn",
    },
    breakpoints: {
      1024: {
        loop: (slides.length > 3)? true : false,
        slidesPerView: 3
      }
    }
  });
});